/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ImportLeadsRestService } from '@gh/builder-shared-data';

import { Observable } from 'rxjs';

import { ImportLeadsBatchId } from '../../system-vars/resources/model/system-vars-import-leads.modes';
import { ImportLeadsTemplate } from './import-leads-tab.model';
import { GoogleDocument } from '@gh/common-internal-shared';

@Injectable()
export class ImportLeadsTabBusinessService {

  constructor(private restService: ImportLeadsRestService) {
  }

  initView(): any {
    return {
      leadsExcelTemplate: this.getExcelTemplate(),
    };
  }

  getBatchId(file: File, isHistorical: boolean): Observable<ImportLeadsBatchId> {
    return this.restService.getBatchId(file, isHistorical);
  }

  getGoogleBatchId(sheet: GoogleDocument, isHistorical: boolean): Observable<ImportLeadsBatchId> {
    return this.restService.getGoogleBatchId(sheet.id, isHistorical);
  }

  getExcelTemplate(): Observable<ImportLeadsTemplate> {
    return this.restService.getExcelTemplate();
  }

  getGoogleSheetTemplate(): Observable<ImportLeadsTemplate> {
    return this.restService.getGoogleSheetTemplate();
  }
}
